<boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
</boi-validation-error-generic>
<div class="bo-d-flex">
  <div [ngClass]="cssClasses" class="field-container">
    <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined">
      <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
    </div>
    <div class="field-input">
      <kendo-autocomplete [data]="optionList ? (optionList | localizeOptionList) : availableOptions"
          [placeholder]="placeholder"
          [(ngModel)]="value" [valueField]="valueField" [filterable]="filterable"
          (filterChange)="filterChange.emit($event)" (valueChange)="onAutocompleteValueChange($event)"
          [disabled]="isFieldDisabled">
            <ng-template *ngIf="hasCustomItemTemplate" kendoAutoCompleteItemTemplate let-dataItem>
              <p class="vo-body-bold-14 p-5">{{ dataItem.FullName }} <span class="vo-body-regular-14">{{ dataItem.EmailAddress }}</span></p>
            </ng-template>
        </kendo-autocomplete>
    </div>
  </div>
  <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
</div>
